import { useContext } from "react";

import { KeycloakContext } from "@/components/keycloak/KeycloakContext";

export function useKeycloak() {
  const context = useContext(KeycloakContext);
  if (!context) {
    throw new Error("useKeycloak must be used within KeycloakProvider");
  }
  return context;
}
